export class ExplorerCardActivationRequest {
        id: string;
        fullName: string;
        firstName: string;
        lastName: string;
        email: string;
        preferredName: string;
        panNumber: string;
        passportNumber: string;
        passportExpiryDate: string;
        passportIssueDate: string;
        passportIssuePlace: string;
        deliveryAddress: string;
        city: string;
        state: string;
        pinCode: number;       
}



export class ExplorerCardIssuanceRequest {
        id: string;
        firstName: string;
        middleName: string;
        lastName: string;
        mobile: string;
        email: string;
        preferredName: string;
        panNumber: string;
        passport: string;
        passportIssueDate: string;
        passportExpiryDate: string;
        passportIssuePlace: string;
        city: string;
        state: string;
        pinCode: string;       
        preferredNameOnCard: string;    
        dateOfBirth: any;  
        addressId: string;
}

